<ng-template #createNewTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ _lawyerName }}</span>
		<app-button
			(click)="createLawyer()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			[testHook]="testHooks.CreateLawyerButton"
			>Create lawyer</app-button
		>
	</div>
</ng-template>

<ng-template #lawyerTemplate let-item>
	<div class="flex items-center" [testHook]="testHooks.LawyerItemDiv">
		<div
			class="w-10 h-10 bg-grey-lighter rounded-md flex justify-center items-center text-sm"
		>
			{{ item.firstName[0] | uppercase }} {{ item.lastName[0] | uppercase }}
		</div>
		<div class="ml-2 font-bold whitespace-nowrap">
			{{ item.firstName | titlecase }} {{ item.lastName | titlecase }}
		</div>
	</div>
</ng-template>

<ng-container *ngIf="lawFirm?.lawyer">
	<div class="flex gap-2">
		<p>Lawyer</p>
		<app-icon
			[icon]="AI_ICON"
			[classes]="AI_CLASSES"
			*ngIf="(fieldMappings$ | async)?.otherPartyLawFirm?.lawyer"
			[matTooltip]="AI_TOOLTIP"
		></app-icon>
	</div>
	<app-member-card
		[firstName]="lawFirm?.lawyer?.firstName"
		[lastName]="lawFirm?.lawyer?.lastName"
		[email]="lawFirm?.lawyer?.email"
		[phone]="lawFirm?.lawyer?.phoneNumber"
		member="LAWYER"
		memberType="lawyer"
		[hoverShadow]="hoverShadow"
		(dropdown)="lawyerDropdownOptionSelect($event)"
		[testHook]="testHooks.MemberCard"
	>
	</app-member-card>
</ng-container>

<div class="flex flex-col">
	<app-auto-complete
		*ngIf="!lawFirm?.lawyer"
		label="Lawyer"
		(onSelect)="setLawyer($event)"
		placeholder="Lastname, firstname"
		[itemGroups]="[
			{ items: [{ value: 'createNew' }], template: createNewTemplate },
			{
				items: searchResult,
				template: lawyerTemplate,
				title: 'Existing Lawyers',
				noResultsMessage: 'No lawyers found',
			},
		]"
		[(ngModel)]="_lawyerName"
		name="dual-dropdown-1"
		(debounce)="searchLawyer($event)"
		[loading]="loading"
		[testHook]="testHooks.LawyerAutoComplete"
	>
	</app-auto-complete>

	<div
		[@openClose]
		*ngIf="showCreateForm"
		class="border border-grey-light rounded-xl p-4 my-4"
	>
		<app-create-employee-side-form
			label="Add Lawyer"
			(onSubmit)="_onCreate($event)"
			(onCancel)="onCancel()"
			[isClient]="isClient"
			[name]="_lawyerName"
			[minify]="true"
			*ngIf="showCreateForm"
		>
		</app-create-employee-side-form>
	</div>
</div>
